export default __webpack_public_path__ + "static/media/photo--lg--32.ce6c8e29.jpg";